import { useEffect, useRef, useState } from 'react'

const useButtonLoader = (defaultValue, loaderColor = '#000', icon) => {
  const buttonref = useRef(null)

  const [loadingValue, setLoadingValue] = useState(false)

  const loader = (data) => {
    setLoadingValue(data)
  }

  useEffect(() => {
    // console.log(buttonref)
    if (buttonref.current) {
      if (loadingValue) {
        buttonref.current.innerHTML =
          buttonref.current.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="color: ${loaderColor}"></span>`
        // buttonref.current.innerHTML = 'hello'
        buttonref.current.disabled = true
      } else {
        buttonref.current.innerHTML = defaultValue
        buttonref.current.disabled = false
      }
    }
  }, [loadingValue, defaultValue, loaderColor])

  return [buttonref, loader]
}

export default useButtonLoader
